import React, { useContext } from 'react';

import { BannerProps } from '../../../Components/UI/Banner/Banner';
import { AccountSettingOption, AccountSettings } from '../../../Types/cloudPlatform';
import { MENUS } from '../../../Utils/Menus';
import { Fetcher } from '../../../Utils/api';
import { TYPES } from '../../../Utils/jwt';

interface GlobalContext {
  request: Fetcher;
  handleOpenMenu: (menu: MENUS) => void;
  handleCloseMenu: () => void;
  openMenu: OpenMenu | null;
  paymentServiceProvidersEnabled: boolean;
  logo: string | null;
  type: TYPES | null;
  handleAddBanner: (props: BannerProps, dismissable: boolean) => () => void;
  banners: BannerProps[];
  accountSettings: AccountSettings;
  isAccountSettingEnabled: (name: AccountSettingOption) => boolean;
}

export interface OpenMenu {
  menu: MENUS;
  time: Date;
}

export const GlobalContext = React.createContext<Partial<GlobalContext>>({
  type: null,
});

const useGlobalContext = (): Partial<GlobalContext> => {
  return useContext(GlobalContext);
};

export default useGlobalContext;
